import React from 'react';
import PropTypes from 'prop-types';

import EditableLogo from './EditableLogo';

export default function EditableTopBar({
    profile,
    onUploadLogo,
    loadingProfileLogo,
}) {
    return (
        <div className="panel">
            <div className="media">
                <div className="media__img">
                    <EditableLogo
                        loading={loadingProfileLogo}
                        profile={profile}
                        uploadLogo={onUploadLogo}
                    />
                </div>
            </div>
        </div>
    );
}

EditableTopBar.propTypes = {
    profile: PropTypes.object.isRequired,
    onUploadLogo: PropTypes.func.isRequired,
    loadingProfileLogo: PropTypes.bool,
};
